import { createAsyncThunk } from "@reduxjs/toolkit";
import { showHideLoader } from "../../common/common.slice";
import { subcontractorsServices } from "../../../services/backOffice/subcontractors/subContractors.services";


// Get AccountStatusCount
const getServiceRegionsAction = createAsyncThunk(
  'subscontractorsSlice/getServiceRegionsAction', (_query, { dispatch, rejectWithValue }) =>{
  dispatch(showHideLoader(true));
  return subcontractorsServices.getServiceRegionsService()
    .then((response) => {
      setTimeout(() => {
        dispatch(showHideLoader(false))
      }, 500)
      return response
    })
    .catch((error: { response: unknown; }) => {
      setTimeout(() => {
        dispatch(showHideLoader(false))
      }, 500)
      return rejectWithValue(error?.response)
    })
}
);

// Get AccountStatusCount
const getServicesAction = createAsyncThunk(
  'subscontractorsSlice/getServicesAction', (_query, { dispatch, rejectWithValue }) =>{
  dispatch(showHideLoader(true));
  return subcontractorsServices.getServicesService()
    .then((response) => {
      setTimeout(() => {
        dispatch(showHideLoader(false))
      }, 500)
      return response
    })
    .catch((error: { response: unknown; }) => {
      setTimeout(() => {
        dispatch(showHideLoader(false))
      }, 500)
      return rejectWithValue(error?.response)
    })
}
);

// Get AccountStatusCount
const getAccountStatusCount = createAsyncThunk(
    'subscontractorsSlice/getAccountStatusCount', (_query, { dispatch, rejectWithValue }) =>{
    dispatch(showHideLoader(true));
    return subcontractorsServices.getAccountStatusCount()
      .then((response) => {
        setTimeout(() => {
          dispatch(showHideLoader(false))
        }, 500)
        return response
      })
      .catch((error: { response: unknown; }) => {
        setTimeout(() => {
          dispatch(showHideLoader(false))
        }, 500)
        return rejectWithValue(error?.response)
      })
  }
);


// Get Subcontractor List Action 
const getSubcontractorsListAction = createAsyncThunk(
    'subscontractorsSlice/getSubcontractorsListAction', (payload: any, {dispatch, rejectWithValue}) =>{
        dispatch(showHideLoader(true));
        return subcontractorsServices.subcontractorsListService(payload)
        .then((response) =>{
            setTimeout(() => {
                dispatch(showHideLoader(false))
            },500)
            return response
        })
        .catch((error: { response: unknown; }) => {
            setTimeout(() => {
              dispatch(showHideLoader(false))
            }, 500)
            return rejectWithValue(error?.response)
        })
    }
);

// Get Subcontractor Details Action 
const getSubcontractorsDetailsAction = createAsyncThunk(
  'subscontractorsSlice/getSubcontractorsDetailsAction', (payload: any, {dispatch, rejectWithValue}) =>{
      dispatch(showHideLoader(true));
      return subcontractorsServices.subcontractorDetailsService(payload)
      .then((response) =>{
          setTimeout(() => {
              dispatch(showHideLoader(false))
          },500)
          return response
      })
      .catch((error: { response: unknown; }) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return rejectWithValue(error?.response)
      })
  }
);

// Upload Subcontractor Documents Action 
const subcontractorsDocumentUploadAction = createAsyncThunk(
  'subscontractorsSlice/subcontractorsDocumentUploadAction', (payload: any, {dispatch, rejectWithValue}) =>{
      dispatch(showHideLoader(true));
      return subcontractorsServices.subcontractorUploadDocumentService(payload)
      .then((response) =>{
          setTimeout(() => {
              dispatch(showHideLoader(false))
          },500)
          return response
      })
      .catch((error: { response: unknown; }) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return rejectWithValue(error?.response)
      })
  }
);

// Delete Subcontractor Documents Action 
const subcontractorsDocumentDeleteAction = createAsyncThunk(
  'subscontractorsSlice/subcontractorsDocumentDeleteAction', (payload: any, {dispatch, rejectWithValue}) =>{
      dispatch(showHideLoader(true));
      return subcontractorsServices.subcontractorDeleteDocumentService(payload)
      .then((response) =>{
          setTimeout(() => {
              dispatch(showHideLoader(false))
          },500)
          return response
      })
      .catch((error: { response: unknown; }) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return rejectWithValue(error?.response)
      })
  }
);

// Upload Subcontractor Documents Action 
const updateSubcontractorsDocumentAction = createAsyncThunk(
  'subscontractorsSlice/updateSubcontractorsDocumentAction', (payload: any, {dispatch, rejectWithValue}) =>{
      dispatch(showHideLoader(true));
      return subcontractorsServices.updateSubcontractorsDocumentService(payload)
      .then((response) =>{
          setTimeout(() => {
              dispatch(showHideLoader(false))
          },500)
          return response
      })
      .catch((error: { response: unknown; }) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return rejectWithValue(error?.response)
      })
  }
);

// Update Subcontractor Details Action
const updateSubcontractorsDetailsAction = createAsyncThunk(
  'subscontractorsSlice/updateSubcontractorsDetailsAction', (payload: any, {dispatch, rejectWithValue}) =>{
      dispatch(showHideLoader(true));
      return subcontractorsServices.updateSubcontractorDetailsService(payload)
      .then((response) =>{
          setTimeout(() => {
              dispatch(showHideLoader(false))
          },500)
          return response
      })
      .catch((error: { response: unknown; }) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return rejectWithValue(error?.response)
      })
  }
);

// Get Subcontractor Notes Action 
const getSubcontractorNotesAction = createAsyncThunk(
  'subscontractorsSlice/getSubcontractorNotesAction', (payload: any, {dispatch, rejectWithValue}) =>{
      dispatch(showHideLoader(true));
      return subcontractorsServices.getSubcontractorNotesService(payload)
      .then((response) =>{
          setTimeout(() => {
              dispatch(showHideLoader(false))
          },500)
          return response
      })
      .catch((error: { response: unknown; }) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return rejectWithValue(error?.response)
      })
  }
);

// Update Subcontractor Details Action
const createSubcontractorNoteAction = createAsyncThunk(
  'subscontractorsSlice/createSubcontractorNoteAction', (payload: any, {dispatch, rejectWithValue}) =>{
      dispatch(showHideLoader(true));
      return subcontractorsServices.createSubcontractorNoteService(payload)
      .then((response) =>{
          setTimeout(() => {
              dispatch(showHideLoader(false))
          },500)
          return response
      })
      .catch((error: { response: unknown; }) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return rejectWithValue(error?.response)
      })
  }
);

// Get Subcontractor Access Token Action 
const getSubcontractorAccessTokenAction = createAsyncThunk(
  'subscontractorsSlice/getSubcontractorAccessTokenAction', (payload: any, {dispatch, rejectWithValue}) =>{
      dispatch(showHideLoader(true));
      return subcontractorsServices.getSubcontractorAccessTokenService(payload)
      .then((response) =>{
          setTimeout(() => {
              dispatch(showHideLoader(false))
          },500)
          return response
      })
      .catch((error: { response: unknown; }) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return rejectWithValue(error?.response)
      })
  }
);

// Search Subcontractors Action
const searchSubcontractorsAction = createAsyncThunk(
  'subscontractorsSlice/searchSubcontractorsAction', (query: string, {dispatch, rejectWithValue}) =>{
      return subcontractorsServices.subcontractorSearchService(query)
      .then((response) =>{
          return response
      })
      .catch((error: { response: unknown; }) => {
          return rejectWithValue(error?.response)
      })
  }
);

// Get Subcontractor Projects Action
const getSubcontractorProjectsAction = createAsyncThunk(
  'subscontractorsSlice/getSubcontractorProjectsAction', (payload: any, {dispatch, rejectWithValue}) =>{
      dispatch(showHideLoader(true));
      return subcontractorsServices.getSubcontractorProjectsService(payload)
      .then((response) =>{
          setTimeout(() => {
              dispatch(showHideLoader(false))
          },500)
          return response
      })
      .catch((error: { response: unknown; }) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return rejectWithValue(error?.response)
      })
  }
);

// Get Subcontractor Payments Action
const getSubcontractorPaymentsAction = createAsyncThunk(
  'subscontractorsSlice/getSubcontractorPaymentsAction', (payload: any, {dispatch, rejectWithValue}) =>{
      dispatch(showHideLoader(true));
      return subcontractorsServices.getSubcontractorPaymentsService(payload)
      .then((response) =>{
          setTimeout(() => {
              dispatch(showHideLoader(false))
          },500)
          return response
      })
      .catch((error: { response: unknown; }) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return rejectWithValue(error?.response)
      })
  }
);

// Export All the Subcontractors Action
export const subcontractorsActions = {
    getServiceRegionsAction,
    getServicesAction,
    getAccountStatusCount,
    getSubcontractorsListAction,
    getSubcontractorsDetailsAction,
    subcontractorsDocumentUploadAction,
    subcontractorsDocumentDeleteAction,
    updateSubcontractorsDocumentAction,
    updateSubcontractorsDetailsAction,
    getSubcontractorNotesAction,
    createSubcontractorNoteAction,
    getSubcontractorAccessTokenAction,
    searchSubcontractorsAction,
    getSubcontractorProjectsAction,
    getSubcontractorPaymentsAction
}
